import { render, staticRenderFns } from "./myaddressadd.vue?vue&type=template&id=34ef9248&scoped=true&"
import script from "./myaddressadd.vue?vue&type=script&lang=js&"
export * from "./myaddressadd.vue?vue&type=script&lang=js&"
import style0 from "./myaddressadd.vue?vue&type=style&index=0&id=34ef9248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef9248",
  null
  
)

export default component.exports